import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/superbuy';

export default function FooterSection() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10 mb-16">
          <div className="col-span-2 md:col-span-1">
            <Link
              to="/"
              className="flex items-center gap-2 text-background-50 font-heading text-lg font-semibold mb-4 whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-leaf-line text-primary-400 text-lg"></i>
              </div>
              superbuysheet
            </Link>
            <p className="text-background-50/50 text-sm leading-relaxed mb-6">
              The ultimate Superbuy Spreadsheet resource hub. Smart shopping starts here.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg border border-background-50/20 flex items-center justify-center hover:border-background-50/50 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-background-50/60 text-sm"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-background-50/20 flex items-center justify-center hover:border-background-50/50 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line text-background-50/60 text-sm"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-background-50/20 flex items-center justify-center hover:border-background-50/50 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-pinterest-line text-background-50/60 text-sm"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-background-50/20 flex items-center justify-center hover:border-background-50/50 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-youtube-line text-background-50/60 text-sm"></i>
                </div>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50/90 text-sm font-semibold mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/90 text-sm font-semibold mb-4">Resources</h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.url}
                    className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/90 text-sm font-semibold mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/#about"
                  className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="#footer"
                  className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/90 text-sm font-semibold mb-4">Connect</h4>
            <ul className="space-y-2.5">
              {footerLinks.connect.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-50/50 hover:text-background-50/80 text-sm whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} superbuysheet.lat — All rights reserved. This site provides educational resources and curated links only.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-50/40 hover:text-background-50/60 text-xs whitespace-nowrap cursor-pointer transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-background-50/40 hover:text-background-50/60 text-xs whitespace-nowrap cursor-pointer transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}